/* =============================================================
   AVISTON NEW YORK - Global JavaScript
   Scroll animations, header, mobile nav, accordions, gallery
   ============================================================= */

(function () {
  'use strict';

  /* ── Scroll Reveal with Stagger ── */
  function initScrollReveal() {
    var els = document.querySelectorAll('.av-fade-in, .av-fade-left, .av-fade-right');
    if (!els.length) return;

    // Anything already on screen at load (e.g. content right under a page
    // header) should be visible immediately, not wait on a scroll-triggered
    // intersection callback - that left a visible gap/washed-out heading.
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < vh && rect.bottom > 0) {
        el.classList.add('is-visible');
      }
    });

    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px -60px 0px' }
    );

    els.forEach(function (el) {
      if (!el.classList.contains('is-visible')) observer.observe(el);
    });
  }

  /* ── Accordion ── */
  function initAccordions() {
    document.querySelectorAll('.av-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = this.closest('.av-accordion__item');
        var isOpen = item.classList.contains('is-open');

        // Close all in same accordion group
        var accordion = item.closest('.av-accordion');
        if (accordion) {
          accordion.querySelectorAll('.av-accordion__item').forEach(function (i) {
            i.classList.remove('is-open');
            var content = i.querySelector('.av-accordion__content');
            if (content) content.style.maxHeight = '0';
            i.querySelector('.av-accordion__trigger').setAttribute('aria-expanded', 'false');
          });
        }

        if (!isOpen) {
          item.classList.add('is-open');
          var content = item.querySelector('.av-accordion__content');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Recalculate any open accordion's max-height on resize (e.g. rotating a
    // phone) - it was fixed to a one-time scrollHeight px value, so reflowed
    // content (more/fewer lines after the width change) stayed clipped or
    // left extra empty space. Bound once globally, not per init() call.
    if (!initAccordions._resizeBound) {
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          document.querySelectorAll('.av-accordion__item.is-open .av-accordion__content').forEach(function (content) {
            content.style.maxHeight = content.scrollHeight + 'px';
          });
        }, 150);
      });
      initAccordions._resizeBound = true;
    }
  }

  /* ── Mobile Nav ── */
  function initMobileNav() {
    var burger = document.getElementById('av-burger');
    var mobileNav = document.getElementById('av-mobile-nav');
    var closeBtn = document.getElementById('av-mobile-nav-close');
    var overlay = document.getElementById('av-mobile-nav-overlay');

    if (!burger || !mobileNav) return;

    function openNav() {
      mobileNav.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      burger.classList.add('is-active');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      mobileNav.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      burger.classList.remove('is-active');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    burger.addEventListener('click', function () {
      if (mobileNav.classList.contains('is-open')) {
        closeNav();
      } else {
        openNav();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (overlay) overlay.addEventListener('click', closeNav);

    // Close mobile nav links on click
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeNav();
      }
    });
  }

  /* ── Sticky Header ── */
  function initStickyHeader() {
    var header = document.getElementById('av-header');
    if (!header) return;

    var lastScroll = 0;
    var ticking = false;

    function onScroll() {
      var scrollY = window.scrollY || window.pageYOffset;
      header.classList.toggle('scrolled', scrollY > 200);
      lastScroll = scrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  }

  /* ── Product Gallery + zoom ── */
  function initProductGallery() {
    var mainImage = document.getElementById('av-main-image');
    var thumbs = document.querySelectorAll('.av-product__thumb');
    var swipe = document.getElementById('av-product-swipe');
    var slides = swipe ? swipe.querySelectorAll('.av-product__swipe-slide') : [];

    function setActiveThumb(thumb) {
      thumbs.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-current', 'false');
      });
      thumb.classList.add('active');
      thumb.setAttribute('aria-current', 'true');
    }

    if (mainImage && thumbs.length > 0) {
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          var img = thumb.querySelector('img');
          var full = thumb.dataset.full || (img && img.src.replace(/width=\d+/, 'width=1000'));
          if (!full) return;

          mainImage.style.opacity = '0';
          setTimeout(function () {
            mainImage.onload = function () { mainImage.style.opacity = '1'; };
            if (thumb.dataset.srcset) {
              mainImage.srcset = thumb.dataset.srcset;
            } else {
              mainImage.removeAttribute('srcset');
            }
            mainImage.src = full;
            if (thumb.dataset.alt) mainImage.alt = thumb.dataset.alt;
            if (mainImage.complete) mainImage.style.opacity = '1';
          }, 200);
          setActiveThumb(thumb);

          // Mobile: thumbnails act as dots for the swipe gallery - scroll to match.
          if (swipe && slides[i] && window.matchMedia('(max-width: 767px)').matches) {
            swipe.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
          }
        });
      });
    }

    // Mobile: swiping the gallery updates which dot/thumbnail is active.
    if (swipe && slides.length > 1 && 'IntersectionObserver' in window) {
      var slideObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
          var idx = Array.prototype.indexOf.call(slides, entry.target);
          if (idx > -1 && thumbs[idx]) setActiveThumb(thumbs[idx]);
        });
      }, { root: swipe, threshold: 0.6 });
      slides.forEach(function (s) { slideObserver.observe(s); });
    }

    // Desktop cursor-tracking zoom
    var frame = document.getElementById('av-zoom-frame');
    if (frame && mainImage) {
      frame.addEventListener('mouseenter', function () { frame.classList.add('is-zooming'); });
      frame.addEventListener('mousemove', function (e) {
        var r = frame.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        mainImage.style.transformOrigin = x + '% ' + y + '%';
      });
      frame.addEventListener('mouseleave', function () {
        frame.classList.remove('is-zooming');
        mainImage.style.transformOrigin = 'center center';
      });
    }
  }

  /* ── Size selector: low-stock + sold-out messaging + add-to-cart sync ── */
  function initSizeSelector() {
    var options = document.getElementById('av-size-options');
    if (!options) return;
    var low = document.getElementById('av-lowstock');
    var soldMsg = document.getElementById('av-soldout-msg');
    var stickySize = document.getElementById('av-sticky-size');
    var inputs = options.querySelectorAll('input[type="radio"]');

    var addBtn = document.getElementById('av-add-btn');
    var addLabel = addBtn ? addBtn.querySelector('.av-add-btn__label') : null;
    var stickyAdd = document.getElementById('av-sticky-add');
    var priceEls = document.querySelectorAll(
      '.av-product__price .price-item--regular, .av-product__price .price-item--sale'
    );

    function refresh(input) {
      if (low) {
        var managed = input.getAttribute('data-managed');
        var inv = parseInt(input.getAttribute('data-inventory'), 10);
        if (managed && managed !== '' && !isNaN(inv) && inv > 0 && inv <= 5) {
          low.textContent = inv + ' remaining in this size.';
          low.hidden = false;
        } else {
          low.hidden = true;
        }
      }
      if (soldMsg) soldMsg.hidden = true;
      if (stickySize) stickySize.textContent = input.getAttribute('data-title');

      var available = input.getAttribute('data-available') === 'true';

      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to Cart' : 'Sold Out';

      if (stickyAdd) {
        stickyAdd.disabled = !available;
        stickyAdd.textContent = available ? 'Add to Cart' : 'Sold Out';
      }

      var price = input.getAttribute('data-price');
      if (price) {
        priceEls.forEach(function (el) { el.textContent = price; });
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () { if (!input.disabled) refresh(input); });
      if (input.disabled) {
        var label = options.querySelector('label[for="' + input.id + '"]');
        if (label) {
          label.addEventListener('click', function (e) {
            e.preventDefault();
            if (soldMsg) {
              soldMsg.textContent = 'Size ' + input.getAttribute('data-title') + ' is away. Back soon.';
              soldMsg.hidden = false;
            }
            if (low) low.hidden = true;
          });
        }
      }
    });

    var checked = options.querySelector('input:checked');
    if (checked) refresh(checked);
  }

  /* ── Pinned story: crossfade to fabric macro at panel 2 ── */
  function initProductStory() {
    var story = document.querySelector('.av-story');
    if (!story || !('IntersectionObserver' in window)) return;
    var model = story.querySelector('.av-story__img--model');
    var macro = story.querySelector('.av-story__img--macro');
    var panel1 = story.querySelector('.av-story__panel[data-panel="1"]');
    var panel2 = story.querySelector('.av-story__panel[data-panel="2"]');
    if (!model || !macro || !panel1 || !panel2) return;
    if (window.matchMedia('(max-width: 1023px)').matches) return;

    function showMacro() { macro.classList.add('is-active'); model.classList.remove('is-active'); }
    function showModel() { model.classList.add('is-active'); macro.classList.remove('is-active'); }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) showModel(); });
    }, { threshold: 0.5 }).observe(panel1);

    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) showMacro(); });
    }, { threshold: 0.5 }).observe(panel2);
  }

  /* ── Sticky mobile add-to-cart bar ── */
  function initStickyBar() {
    var bar = document.getElementById('av-sticky-bar');
    var panel = document.querySelector('.av-product__info');
    if (!bar || !panel || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.av-footer');
    var panelOut = false, footerIn = false;

    function update() {
      var show = panelOut && !footerIn;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    new IntersectionObserver(function (es) {
      es.forEach(function (e) { panelOut = !e.isIntersecting; update(); });
    }, { threshold: 0 }).observe(panel);

    if (footer) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { footerIn = e.isIntersecting; update(); });
      }, { threshold: 0 }).observe(footer);
    }

    var stickyAdd = document.getElementById('av-sticky-add');
    var form = document.getElementById('ProductForm');
    if (stickyAdd && form) {
      stickyAdd.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* ── Add to cart (AJAX) + microfeedback + open drawer ── */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var wrap = document.querySelector('.av-header__cart-icon-wrap');
        var badge = document.querySelector('.av-header__cart-count');
        if (c.item_count > 0) {
          if (!badge && wrap) {
            badge = document.createElement('span');
            badge.className = 'av-header__cart-count';
            wrap.appendChild(badge);
          }
          if (badge) badge.textContent = c.item_count;
        } else if (badge) {
          badge.remove();
        }
      }).catch(function () {});
  }

  function openCartDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') d.open();
  }

  function initAddToCart() {
    var form = document.getElementById('ProductForm');
    if (!form) return;
    var btn = document.getElementById('av-add-btn');
    var labelSpan = btn ? btn.querySelector('.av-add-btn__label') : null;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn && btn.disabled) return;

      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);

      var original = labelSpan ? labelSpan.textContent : 'Add to Cart';
      if (btn) btn.classList.add('is-added');
      if (labelSpan) {
        labelSpan.innerHTML = 'Added <svg class="av-add-btn__check" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>';
      }

      var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.status) return; // add error, leave page as-is
          var drawer = document.querySelector('cart-drawer');
          if (drawer && res.sections && typeof drawer.renderContents === 'function') {
            drawer.renderContents(res);
          } else {
            openCartDrawer();
          }
          updateCartCount();
        })
        .catch(function () {})
        .finally(function () {
          setTimeout(function () {
            if (btn) btn.classList.remove('is-added');
            if (labelSpan) labelSpan.textContent = original || 'Add to Cart';
          }, 1200);
        });
    });
  }

  /* ── Header cart opens the drawer ── */
  function initCartTriggers() {
    var cartLink = document.querySelector('.av-header__cart');
    var drawer = document.querySelector('cart-drawer');
    if (cartLink && drawer && typeof drawer.open === 'function') {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        drawer.open(cartLink);
      });
    }
  }

  /* ── Smooth Anchor Scrolling ── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── Email Capture ── */
  function initEmailCapture() {
    var form = document.getElementById('av-footer-email-form');
    if (!form) return;
    var success = form.parentElement.querySelector('.av-footer__email-success');
    var error = form.parentElement.querySelector('.av-footer__email-error');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      if (!input || !input.value) return;

      if (error) error.hidden = true;

      var data = new FormData(form);
      fetch(form.action, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        var contentType = response.headers.get('content-type') || '';
        if (contentType.indexOf('json') === -1) return null;
        return response.json();
      }).then(function (json) {
        // Shopify's customer form can respond 200 OK but still carry form
        // errors in the JSON body (e.g. invalid email) - that's a failure too.
        if (json && json.errors) throw new Error('Form errors');
        form.style.display = 'none';
        if (success) success.style.display = 'block';
      }).catch(function () {
        if (error) error.hidden = false;
      });
    });
  }

  /* ── Contact form: inline validation (gold, no bubbles) ── */
  function initContactForm() {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var email = document.getElementById('ContactForm-email');
    var body = document.getElementById('ContactForm-body');
    var errEmail = document.getElementById('err-email');
    var errBody = document.getElementById('err-body');

    function setError(field, el, msg) {
      if (!el) return false;
      if (msg) {
        el.textContent = msg;
        el.hidden = false;
        if (field) field.setAttribute('aria-invalid', 'true');
        return false;
      }
      el.hidden = true;
      if (field) field.removeAttribute('aria-invalid');
      return true;
    }

    function validEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    form.addEventListener('submit', function (e) {
      var ok = true;
      if (email && !validEmail(email.value.trim())) {
        setError(email, errEmail, 'Enter a valid email and we will keep you posted.');
        ok = false;
      } else {
        setError(email, errEmail, '');
      }
      if (body && body.value.trim().length === 0) {
        setError(body, errBody, 'Add a short message and we will take it from there.');
        ok = false;
      } else {
        setError(body, errBody, '');
      }
      if (!ok) {
        e.preventDefault();
        var firstBad = form.querySelector('[aria-invalid="true"]');
        if (firstBad) firstBad.focus();
      }
    });

    [email, body].forEach(function (f) {
      if (!f) return;
      f.addEventListener('input', function () {
        if (f === email && validEmail(f.value.trim())) setError(email, errEmail, '');
        if (f === body && f.value.trim().length > 0) setError(body, errBody, '');
      });
    });
  }

  /* ── Init ── */
  function init() {
    initScrollReveal();
    initAccordions();
    initMobileNav();
    initStickyHeader();
    initProductGallery();
    initSizeSelector();
    initProductStory();
    initStickyBar();
    initAddToCart();
    initCartTriggers();
    initSmoothScroll();
    initEmailCapture();
    initContactForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor - re-init on section load/reorder
  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
    initAccordions();
    initProductGallery();
    initSizeSelector();
    initProductStory();
    initStickyBar();
    initAddToCart();
  });

})();
